import { useMutation } from '@tanstack/react-query'
import { useAPI } from '../../../Contexts/APIContext'

export const useEditTeaseLyrics = () => {
  const { editTeaseLyrics } = useAPI()

  return useMutation({
    mutationFn: data =>
      editTeaseLyrics({
        ...data,
      }),
  })
}
